module.exports = function (app, mod, nft_overlay) {
  var nft = nft_overlay.nft;
  var text = '';
  if (nft.text) {
    text = nft.text;
  }
  if (nft.css) {
    text = nft.css;
  }
  if (nft.js) {
    text = nft.js;
  }
  if (nft.json) {
    text = nft.json;
  }
  var imageHtml = '';
  if (text == '') {
    imageHtml = "<div class=\"saito-nft-image\" style=\"background-image:url('".concat((nft === null || nft === void 0 ? void 0 : nft.image) || '/saito/img/dreamscape.png', "')\" ></div>");
  } else {
    imageHtml = "<div class=\"saito-nft-image\" style=\"background-image:url('".concat((nft === null || nft === void 0 ? void 0 : nft.image) || '/saito/img/dreamscape.png', "')\" ><div class=\"saito-nft-text\">").concat(text, "</div></div>");
  }
  var descriptionHtml = '';
  if (nft.description && nft.description.trim()) {
    descriptionHtml = "\n      <div class=\"saito-nft-description-box-overlay\">\n        <div class=\"saito-nft-description-text-overlay\">".concat(nft.description, "</div>\n      </div>\n    ");
  }
  return "\n    <div class=\"saito-nft-panel saito-nft-panel-view active\">\n      <div class=\"saito-nft-panel-body saito-nft-panel-body-view\">\n        <div class=\"saito-nft-image-wrapper\">\n          ".concat(imageHtml, "\n          ").concat(descriptionHtml, "\n        </div>\n      </div>\n      <div class=\"saito-nft-panel-footer\">\n        <button class=\"saito-nft-footer-btn enable-nft\" style=\"display:none;\">Enable</button>\n        <button class=\"saito-nft-footer-btn disable-nft\" style=\"display:none;\">Disable</button>\n        <button class=\"saito-nft-footer-btn send-nft\">Transfer</button>\n      </div>\n    </div>\n  ");
};